import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Select } from '@ngxs/store';
import { DefaultModalConfig, ModalsService, ModulesSelectors } from '@serviceos-ng/core';
import { Observable, Subscription } from 'rxjs';
import { BraintreeComponent } from './braintree/braintree.component';
import { StripeComponent } from './stripe/stripe.component';

@Component({
    selector: 'serviceos-web-payments',
    templateUrl: './payments.component.html',
    styleUrls: ['./payments.component.scss'],
})
export class PaymentsComponent implements OnInit, OnDestroy {
    @Input()
    public paymethodSetup: {
        type: string;
        payload: {
            public_key: string;
            unsupported_brands: Array<string>;
            client_secret: string;
        };
    } | null = null;

    @Input()
    private typeOfCard: 'new' | 'existing' = 'new';

    @Input()
    public selectedTypeOfPayment:
        | 'Stripe'
        | 'Braintree'
        | 'ApplePay'
        | null = null;

    @ViewChild(StripeComponent)
    private stripePayment: StripeComponent | null = null;

    @ViewChild(BraintreeComponent)
    private braintreePayment: BraintreeComponent | null = null;

    private stripeCompInitSubscription: Subscription | null = null;

    @Select(ModulesSelectors.getComponentFromModule('customer', 'payments'))
    paymentsConfig$!: Observable<any>

    public paymentsConfig: any = null;

    constructor(private _modalsService: ModalsService) {
        this.paymentsConfig$.subscribe((config) => {
            if (config) {
                this.paymentsConfig = config;
            }
        });
    }

    ngOnInit(): void {
        this.initialize();
    }

    ngOnDestroy(): void {
        if (this.stripeCompInitSubscription) {
            this.stripeCompInitSubscription.unsubscribe();
        }
    }

    private initialize(): void {
        // console.warn('paymethodSetup', this.paymethodSetup);
    }

    /**
     * Generic method for generating token of provided payment method type
     * @param paymethodSetup
     */
    public generateToken(): Promise<{ token: string; device_data?: any }> {
        return new Promise((resolve, reject) => {
            if (this.typeOfCard === 'new') {
                this.generatePaymentData(resolve, reject);
            } else {
                //
            }
        });
    }

    /**
     * Method invokes currently selected payment method's library to generate request payload for payments
     * @param resolve
     * @param reject
     */
    private generatePaymentData(resolve: Function, reject: Function) {
        const selectedPaymentMethodCompRef:
            | StripeComponent
            | BraintreeComponent = this.getSelectedPaymentMethodComponentRef();

        selectedPaymentMethodCompRef
            .getPaymentObject(this.typeOfCard)
            .then(
                (paymentData: any) => {
                    if (this.stripeCompInitSubscription) {
                        this.stripeCompInitSubscription.unsubscribe();
                    }

                    resolve(paymentData);
                },
                (error: any) => {
                    if (this.stripeCompInitSubscription) {
                        this.stripeCompInitSubscription.unsubscribe();
                    }

                    // if there's no message - the promise rejection is from form frontent validation
                    if (error && error.message) {
                        this._modalsService.open(
                            new DefaultModalConfig(
                                '', 
                                error.message,
                                [
                                    {
                                        title: 'Ok',
                                        type: 'close',
                                    },
                                ],
                                'error'
                            )
                        );
                    }

                    reject(error);
                }
            );
    }

    /**
     * Retrieve currently selected payment method
     */
    private getSelectedPaymentMethodComponentRef(): any {
        switch (this.selectedTypeOfPayment) {
            case 'Stripe':
                return this.stripePayment;
            case 'Braintree':
                return this.braintreePayment;
        }
    }
}
